"use strict";

import angular from "angular";
import "./themes/scenario-options-menu.scss";
import "./themes/scenario-options-menu-dark.scss";

class ScenarioOptionsMenuComponent {
    constructor() {}

    $onInit() {}

    hideOption(option) {
        if (!option.hide) return false;
        return option.hide(this.serie, this.month);
    }
}

ScenarioOptionsMenuComponent.$inject = [];

const name = "scenarioOptionsMenuComponent";
const def = {
    template: `
        <md-menu
            md-position-mode="left bottom"
            class="scenario-options-menu-component"
        >
            <md-button
                class="md-icon-button desnu-button-icon desnu-button-small options-menu__button"
                aria-label="Opções"
                ng-click="$mdMenu.open($event)"
            >
                <i
                    class="dsn-icon-button fas fa-pencil-alt"
                ></i>
            </md-button>

            <md-menu-content class="dsn-menu">
                <md-menu-item class="dsn-menu-item" ng-repeat="option in $ctrl.options track by $index" ng-hide="$ctrl.hideOption(option)">
                    <md-button
                        aria-label="{{ option.label }}"
                        class="dsn-menu-item-button"
                        ng-click="$ctrl.onClickOption({option})"
                        ng-disabled="option.disabled"
                    >
                        <p class="dsn-menu-item-label">
                            {{ option.label }}
                        </p>
                    </md-button>
                </md-menu-item>
            </md-menu-content>
        </md-menu>
    `,
    bindings: {
        options: "<",
        onClickOption: "&",
        serie: "<",
        month: "<"
    },
    controller: ScenarioOptionsMenuComponent
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
